<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <form @submit.prevent="login">
                    <div slot="no-body" class="full-page-bg-color">
                        <div class="vx-row no-gutter justify-center items-center">
                            <div class="vx-col hidden lg:block lg:w-1/2">
                                <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                            </div>
                            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                                <div class="p-8">
                                    <div class="vx-card__title mb-8">
                                        <h4 class="mb-4">Login</h4>
                                        <p>Welcome back, please login to your account.</p>
                                        <p class="text-danger">{{ message }}</p>
                                    </div>
                                    <vs-input
                                        v-validate="'required|min:3'"
                                        data-vv-validate-on="blur"
                                        name="username"
                                        icon-pack="fa" icon="fa-user-alt"
                                        label-placeholder="Username"
                                        v-model="username"
                                        class="w-full no-icon-border"
                                        :autofocus="true" />
                                    <span class="text-danger text-sm">{{ errors.first('username') }}</span>

                                    <vs-input
                                        data-vv-validate-on="blur"
                                        v-validate="'required|min:3|max:10'"
                                        type="password"
                                        name="password"
                                        icon-pack="fa" icon="fa-key"
                                        label-placeholder="Password"
                                        v-model="password"
                                        class="w-full mt-6 no-icon-border" />
                                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <div class="flex flex-wrap justify-between my-5">
                                        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
                                        <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                                    </div>
                                    <!-- <vs-button  type="border" @click="registerUser">Register</vs-button> -->
                                    <vs-button class="float-right" :disabled="!validateForm" @click.prevent="login">Login</vs-button>

                                    <p>&nbsp;</p>
                                    <p>&nbsp;</p>

                                </div>
                                
                            </div>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>

<script>
    // username: 'demo@demo.com',  password: 'demodemo',
import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
/*
const os = require('os');

const platform=os.platform();
console.log('platform='+platform);

const inter=os.networkInterfaces();
console.log('network='+JSON.stringify(inter));

var macaddress = require('macaddress');

macaddress.one(function (err, mac) {
  console.log("Mac address for this host: %s", mac);  
});
*/
export default {
    mixins: [common],
    data() {
        return {
            username: 'admin',
            password: '',
            checkbox_remember_me: false,
            message: ''
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.username != '' && this.password != '';
        },
    },
    methods: {
        getData(where, url){
            return this.getRecords(where, url);
        },
        login() {
           /* 
            const payload = {
                checkbox_remember_me: this.checkbox_remember_me,
                userDetails: {
                    username: this.username,
                    password: this.password
                },
                notify: this.$vs.notify
            }
            this.$store.dispatch('auth/loginAttempt', payload);
            */

           this.pageLoadingOn();

           var where = {
               'username': this.username,
               'password': this.password,
           };
           console.log('url='+url+', where='+JSON.stringify(where));

            var server_url = companyConfig.apiURL;
            var server_mac = companyConfig.MACAddress;
            var server_flag = companyConfig.Server;
            console.log('server_url='+url+', server_mac='+server_mac+', server_flag='+server_flag);

            var url='lib/api/users/check';
            url=server_url+url;
            console.log('url='+url);

            let thisIns = this;
            var output="";
            var flag=0;
            var records ={};
            
            this.$http({
                url: url,
                method: 'POST',
                data: {
                    'where': where
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then(function (response) {

                thisIns.pageLoadingOff();
                console.log('response='+JSON.stringify(response));
                output = response.data.output;
                flag = response.data.flag;
                console.log('output='+output+', flag='+flag);

                if (flag == 1) {
                    records = response.data.records[0];
                    // thisIns.message = 'loading....';
                    var user = records.username;
                    var UserDisplayName = records.display_name;
                    var role = records.role_id;
                    var userRole = records.role_name;
                    var CompanyId = records.company_code;
                    var CompanyStateId = records.company_state_id;
                    var mac = records.mac;
                    var token = records.token;
                    var licence_flag=server_mac == mac ? 1 : 0;
                    console.log('user='+user+', role='+role+', userRole='+userRole+', CompanyId='+CompanyId+', CompanyStateId='+CompanyStateId+', token='+token+', server_mac='+server_mac+', mac='+mac+', licence_flag='+licence_flag);

                    if (licence_flag == 1 || server_flag == 1) {
                        userRole = role == 2 ? 'admin' : 'editor';
                        thisIns.$session.start();
                        thisIns.$session.set('username', user);
                        thisIns.$session.set('UserDisplayName', UserDisplayName);
                        thisIns.$session.set('role', role);
                        thisIns.$session.set('role_name', userRole);
                        thisIns.$session.set('CompanyId', CompanyId);
                        thisIns.$session.set('CompanyStateId', CompanyStateId);
                        thisIns.$session.set('token', token);
                        thisIns.pageLoadingOn();
                        thisIns.$router.push('/dashboard/admin');
                        localStorage.setItem('userRole', userRole);
                        // thisIns.$acl.change(userRole);
                        // thisIns.$store.dispatch('updateUserRole', {aclChangeRole: thisIns.$acl.change, role: userRole})

                        /*
                        thisIns.$router.push({
                            path: '/party/pricegroups/list',
                            query: {
                                name: 'raj',
                                username: 'raj@gmail.com',
                                marks: 100
                            }
                        });
                        */                                                
                    } else {
                        var errTxt='Kindly purchase to continue our service.';
                        thisIns.errorMessage(errTxt);
                    }
                    
                }else{
                    // thisIns.message = output;
                    // thisIns.username = "";
                    thisIns.password = "";
                    thisIns.errorMessage(output);
                }                
            })
            .catch(function (error) {
                console.log('error='+error);
            })

        },

        loginAuth0() {
            if (this.$store.state.auth.isUserLoggedIn()) {
                this.notifyAlreadyLogedIn();
                return false
            }
            this.$auth.login({ target: this.$route.query.to });
        },

        // Google login
        loginWithGoogle() {
            this.$store.dispatch('auth/loginWithGoogle', {notify: this.$vs.notify})
        },

        // Facebook login
        loginWithFacebook() {
            this.$store.dispatch('auth/loginWithFacebook', {notify: this.$vs.notify})
        },

        // Twitter login
        loginWithTwitter() {
            this.$store.dispatch('auth/loginWithTwitter', {notify: this.$vs.notify})
        },

        // Github login
        loginWithGithub() {
            this.$store.dispatch('auth/loginWithGithub', {notify: this.$vs.notify})
        },

        notifyAlreadyLogedIn() {
            this.$vs.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        },
        registerUser() {
            if(this.$store.state.auth.isUserLoggedIn()) {
                this.notifyAlreadyLogedIn();
                return false;
            }
            this.$router.push('/pages/register');
        }
    }
}
</script>

<style lang="scss">
#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #4285F4;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
</style>
